import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { PermissionsService } from '../../shared/services/permissions.service';
import { EditionService }       from './../../shared/services/edition.service';

interface Tab {title: string, routeArray?: string[], learningPath?: string};

@Component({
  selector: 'app-dashboard-navigation',
  templateUrl: './dashboard-navigation.component.html',
  styleUrls: ['./dashboard-navigation.component.less'],
})

export class DashboardNavigationComponent implements OnInit {
  active: number=0;
  tabs: Tab[];
  constructor(
    private router: Router,
    private permissionsService: PermissionsService,
    private editionService: EditionService,
  ) {}

  ngOnInit(): void {
    // path without leading slash or query params
    let currentRoute = this.router.url.split('?')[0].substring(1);
    this.tabs = [];

    this.permissionsService.retrievePermissions().subscribe(permissions => {
      const canSeePrograms = permissions.programAdministration || permissions.editionAdministration || permissions.nomadicAdministration
      const canSeeJourneys = permissions.editJourneys || permissions.editionAdministration || permissions.nomadicAdministration
      const canSeeResources = permissions.editProgramContent || permissions.nomadicAdministration;
      this.tabs = [];

      if (canSeeJourneys && !canSeePrograms && !permissions.sessionManagement) {
        this.router.navigate(["dashboard", "journeys"]);
      }
      if (canSeePrograms) {
        this.tabs.push({ title:'Programs', routeArray: ["dashboard"] })
      }
      if (permissions.axaEntityUserManagement) {
        this.tabs.push({ title:'Users', routeArray: ["dashboard", "entity-users"] });
      }
      if (permissions.sessionManagement) {
        this.tabs.push({ title:'Programs & Sessions', routeArray: ["dashboard", "new-programs"] });
      }
      if (permissions.sessionManagement) {
        this.tabs.push({ title:'Learner Journeys', routeArray: ["dashboard", "journeys"] });
      }
      if (canSeeResources) {
        this.tabs.push({ title: 'Manage Resources', learningPath: "/cms/resources"});
      }
      this.active = this.tabs.findIndex(t => t.routeArray && t.routeArray.join('/') == currentRoute) || 0;
    });
  }

  public handleTabClick(title: string): void {
    console.log('title', title, this.tabs)
    let clickedIndex = this.tabs.findIndex(t => t.title == title);
    if (clickedIndex >= 0  && this.active !== clickedIndex) {
      if (this.tabs[clickedIndex].routeArray) {
        this.router.navigate(this.tabs[clickedIndex].routeArray);
      } else if (this.tabs[clickedIndex].learningPath)  {
        let path = this.tabs[clickedIndex].learningPath;
        this.editionService.jumpToLearning(path);
      }
    }
  }

  public tabName(index: number, tab: Tab) {
    return tab.title;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard-navigation/dashboard-navigation.component.ts